



























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationProvider
  }
})
export default class TextField extends Vue {
  @Prop({ default: "" }) value?: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: "" }) dataCy?: string;
  @Prop({ default: "" }) placeholder?: string;
  @Prop({ default: "" }) label?: string;
  @Prop() rules?: string;
  @Prop() validationField?: string;
  @Prop({ default: false }) isTextSearch?: boolean;
  @Prop() onSearchText?: (text: string) => Promise<void>;
  @Prop() onClearText?: () => Promise<void>;

  searchComplete?: boolean = false;

  onValueUpdated(value: unknown[] | undefined) {
    this.$emit("input", value);
  }

  searchText() {
    if (!this.value) return;

    this.searchComplete = true;

    if (this.onSearchText != null) this.onSearchText(this.value);
  }

  clearSearch() {
    this.searchComplete = false;

    if (this.onClearText != null) this.onClearText();
  }
}
